const DEFAULT_TAB_BUTTON_SELECTOR =
  '.page-tabs__nav-link.no-link, .residency-lk-sidebar__nav-link.no-link';
const DEFAULT_TAB_CONTENT_SELECTOR = '.tab-content';

interface TabWidgetOptions {
  rootSelector: string;
  tabButtonSelector?: string;
  tabContentSelector?: string;
}

export class TabWidget {
  private rootSelector: string;
  private root: HTMLElement | null;
  private tabButtons: NodeListOf<Element> | undefined;
  private tabContents: NodeListOf<Element> | undefined;

  constructor(options: TabWidgetOptions) {
    this.rootSelector = options.rootSelector;
    this.root = document.querySelector(this.rootSelector);
    const tabBtnSel = options.tabButtonSelector ?? DEFAULT_TAB_BUTTON_SELECTOR;
    const tabContentSel = options.tabContentSelector ?? DEFAULT_TAB_CONTENT_SELECTOR;
    this.tabButtons = this.root?.querySelectorAll(tabBtnSel);
    this.tabContents = this.root?.querySelectorAll(tabContentSel);
  }

  public init(tabId?: number, onTabClick?: (tabId?: number) => void): void {
    if (!this.root) return;
    this.bindEvents(onTabClick);
    if (tabId !== undefined && this?.tabButtons?.[tabId]) {
      this.setActiveTab(tabId);
    } else {
      this.setActiveTab(0);
    }
  }

  private bindEvents(onTabClick?: (tabId?: number) => void): void {
    if (!this.tabButtons) return;
    this.tabButtons.forEach((tabButton, index) => {
      tabButton.addEventListener('click', () => {
        this.setActiveTab(index);

        if (onTabClick) {
          onTabClick(index);
        }
      });
    });
  }

  private setActiveTab(activeIndex: number): void {
    if (!this.tabButtons || !this.tabContents) return;
    this.tabButtons.forEach((tab, index) => {
      if (index === activeIndex) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });
    this.tabContents.forEach((tabContent, index) => {
      if (index === activeIndex) {
        tabContent.classList.remove('hidden');
      } else {
        tabContent.classList.add('hidden');
      }
    });
  }
}
